import { BaseEvent, FlushPriority, TransportDelegate } from '@mmt/events-schema'
import { NetworkClient } from '../../core/platform-interfaces/network-client'
import { updateDomain, updateHeaders } from './utils'
import { appSettingsInstance } from '../../core/global-state/global-data'

type ReqHeaders = Record<string, string>
const PDT_HOST = 'https://pdt.makemytrip.com'
const SEND_EVENT_ENDPOINT = `/dts/s/da/n`
const PDT_REQ_HEADERS: ReqHeaders = {
  'Content-Type': 'application/json',
  // 'Content-Encoding': 'gzip',
  'Request-Data-Encoding': 'json',
  'Accept-Encoding': 'gzip',
}

export const PdtNetworkConstants = {
  PDT_HOST,
  SEND_EVENT_ENDPOINT,
  PDT_REQ_HEADERS,
}

export type BrowserNetworkClientOptions = {
  host?: string
  sendEndpoint?: string
  baseHeaders?: ReqHeaders
}
export class BrowserNetworkClient<T> implements NetworkClient<T> {
  private readonly _host: string
  private readonly _sendEndpoint: string
  private readonly _baseHeaders: ReqHeaders

  constructor(options?: BrowserNetworkClientOptions) {
    this._host = options?.host || ''
    appSettingsInstance.setSetting('pdtHost', this._host)
    this._sendEndpoint = `${updateDomain(this._host)}${options?.sendEndpoint || SEND_EVENT_ENDPOINT}`
    this._baseHeaders = updateHeaders(options?.baseHeaders || PDT_REQ_HEADERS, updateDomain(this._host))
  }

  async sendEvents(
    events: Array<BaseEvent<T>>,
    priority: FlushPriority,
    workerDelegate: TransportDelegate<T> | null,
  ): Promise<'success' | 'failed'> {
    if (workerDelegate) {
      return workerDelegate({
        events,
        priority,
        headers: this._baseHeaders,
        endpoint: this._sendEndpoint,
      })
    }
    const requestBody = JSON.stringify(events)
    await fetch(this._sendEndpoint, {
      method: 'POST',
      body: requestBody,
      headers: this._baseHeaders,
      keepalive: true,
    })
    return Promise.resolve('success')
  }
}
